var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadedPage)?_c('div',{staticClass:"admin-entity-content--container"},[(_vm.loadedPage)?_c('EntityEditor',{attrs:{"title":_vm.hyperlink.name,"entity-type":"Hyperlink","entity":_vm.hyperlink,"admin":true}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }